import forge from 'node-forge'

// Both references must stay on ONE line - the cloudbuild `inject-secrets` sed that
// replaces them is line-based. See the note in src/utils/constants.ts.
// prettier-ignore
const sec_key = "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAuOoOFWc6kVw268Z49Ob8BYeK2KkrQ+vic4UcU6pppwq5xDDCqbXxRfXPazwx9KyaoPndaoXUHqB+ljYuURapryvPI5e0AuMXf/SfMdcvSVzEpHbkAsItN1Q9TBnbTW1tLyZ3yeeMHSJqpqlTkJIKtB4FW7qdDeq4f9QP9zcR8vZKzv2LhQPKvpHf4TvvoNrqDHYylN7hABDOR61/yO3rQqkpztEeV0Xha6muKY4RhO2fvHpXAdkyBlzar+4inSQd2zhzITLqFOwqlpnZv9xH6m51CeLFHPSzOsZVLv5eSASo2Bk3p3TPBBnzGoLFCjBOaUxOoWhM2l2Mrw+C2ng+UQIDAQAB"
// prettier-ignore
const iv = "60K0LV7ePt8fLQ=="

if (!sec_key || !iv) {
  throw new Error('Some data not found.')
}
const pubKey = sec_key
const publicKeyPem = `-----BEGIN PUBLIC KEY-----\n${pubKey}\n-----END PUBLIC KEY-----`

export const encryptAES = (text: any, aesKey: string) => {
  const aesKeyBuffer = forge.util.createBuffer(forge.util.decode64(aesKey))
  const cipher = forge.cipher.createCipher('AES-CBC', aesKeyBuffer)
  cipher.start({ iv })
  cipher.update(forge.util.createBuffer(JSON.stringify(text), 'utf8'))
  cipher.finish()

  const ciphertext = cipher.output.getBytes()
  return {
    encryptedData: forge.util.encode64(ciphertext),
    id: encryptRSA(aesKey),
  }
}

export const decryptAES = (encryptedData: string, aesKey: string) => {
  const aesKeyBuffer = forge.util.createBuffer(forge.util.decode64(aesKey))
  const decipher = forge.cipher.createDecipher('AES-CBC', aesKeyBuffer)
  decipher.start({ iv })
  decipher.update(forge.util.createBuffer(forge.util.decode64(encryptedData)))
  const success = decipher.finish()

  if (!success) {
    throw new Error('Decryption failed!')
  }

  return JSON.parse(decipher.output.toString())
}

export const encryptRSA = (data: string) => {
  const publicKey = forge.pki.publicKeyFromPem(publicKeyPem)
  const encrypted = publicKey.encrypt(data, 'RSAES-PKCS1-V1_5') // "RSA/ECB/PKCS1Padding"
  return forge.util.encode64(encrypted)
}
